<template>
  <div>
    <p v-html="formattedString" />
    <template v-if="text.length > maxChars">
      <a
        v-if="!isReadMore"
        id="readmore"
        :href="link"
        class="read-more"
        @click="triggerReadMore($event, true)"
      >{{ more }}</a>
      <a
        v-if="isReadMore"
        id="readmore"
        :href="link"
        class="read-more"
        @click="triggerReadMore($event, false)"
      >{{ less }}</a>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    more: {
      type: String,
      default: 'Read More'
    },
    less: {
      type: String,
      default: 'Read Less'
    },
    text: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: '#'
    },
    maxChars: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      isReadMore: false
    }
  },
  computed: {
    formattedString() {
      let val_container = this.text
      if (!this.isReadMore && this.text.length > this.maxChars) {
        val_container = val_container.substring(0, this.maxChars) + '...'
      }
      return val_container
    }
  },
  methods: {
    triggerReadMore(e, b) {
      if (this.link == '#') {
        e.preventDefault()
      }
      if (this.lessStr !== null || this.lessStr !== '') this.isReadMore = b
    }
  }
}
</script>

<style lang="scss" scoped>
a {
    color:var(--vc-link-color);
}
</style>
